<template>
  <TransitionRoot as="template" :show="isOpen">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="$emit('close')">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 dark:bg-true-gray-900 dark:bg-opacity-75 bg-warm-gray-900 bg-opacity-75" />
        </TransitionChild>
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="inline-block align-bottom dark:bg-true-gray-800 bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6">
            <div class="block absolute top-0 right-0 pt-4 pr-4">
              <button type="button" class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" @click="$emit('close')" :disabled="isSubmitting">
                <span class="sr-only">Close</span>
                <XIcon class="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div class="relative px-4 sm:px-6 max-w-xl mx-auto py-4 mt-4 text-center">
              <span class="block text-base dark:text-yellow-300 text-yellow-500 font-semibold tracking-wide uppercase">MTP Entrance Reviewer</span>
              <h1 class="text-2xl tracking-tight font-extrabold dark:text-gray-300 text-gray-700 md:text-3xl my-6">
                Preparing for MTP?
              </h1>
              <p class="my-4 dark:text-gray-400 text-gray-600">
                Test yourself with a free sample mock exam based on the MTP Entrance test. Ready to take the challenge?
              </p>

              <div class="my-6">
                <div class="w-full overflow-hidden rounded-lg border border-true-gray-700 dark:border-true-gray-600">
                  <img
                    src="@/assets/images/mtp-app-modules-preview.jpg"
                    alt="Preview of the new MTP reviewer modules"
                    class="w-full h-auto object-cover object-top"
                  />
                </div>
              </div>

              <button
                type="button"
                @click="$emit('open-app')"
                :disabled="isSubmitting"
                class="mt-2 text-white bg-indigo-600 w-full py-4 border border-transparent rounded-md shadow-sm px-4 inline-flex justify-center text-lg font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-30"
              >
                Start Free Mock Exam
              </button>
              <button
                type="button"
                @click="$emit('dismiss')"
                :disabled="isSubmitting"
                class="mt-3 w-full py-3 text-sm font-medium dark:text-gray-400 text-gray-500 hover:text-gray-700 dark:hover:text-gray-200"
              >
                Don't show this banner again
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { XIcon } from "@heroicons/vue/solid";
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay,
} from "@headlessui/vue";

export default {
  components: { XIcon, TransitionRoot, TransitionChild, Dialog, DialogOverlay },
  props: {
    isOpen: { type: Boolean, default: false },
    isSubmitting: { type: Boolean, default: false },
  },
  emits: ["close", "dismiss", "open-app"],
};
</script>
